// extracted by mini-css-extract-plugin
module.exports = {"tab":"tabnav_tab__7hlnJ","active":"tabnav_active__1tXUC"};